import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import Link from 'react-router-dom/Link'
import { redirectToPage } from 'srcReact/helpers/history'

const AnchorLink = ({
  path = '',
  isReactLink,
  handleClick,
  className,
  icon,
  children,
  isNative,
  backNavigation,
  ...rest
}) => {
  const renderChildren = () => {
    return (
      <React.Fragment>
        {icon && icon.position === 'start' && (
          <Icon name={icon.name} styleModifier={icon.styleModifier} alt={icon.alt} size={icon.size} />
        )}
        {children}
        {icon && icon.position === 'end' && (
          <Icon name={icon.name} styleModifier={icon.styleModifier} alt={icon.alt} size={icon.size} />
        )}
      </React.Fragment>
    )
  }

  const handleOnClick = (e) => {
    if (handleClick) {
      handleClick(e)
    }
    //back navigation state passing is not possible with anchor tag(in case of native),
    //so we have to use redirectToPage and prevent default behavour of href
    if (isNative && backNavigation) {
      e.preventDefault()
      redirectToPage(path, true, backNavigation)
    }
  }
  const anchorStyles = `${styles.link} ${className}`
  return isNative || !isReactLink ? (
    <a href={path} onClick={handleOnClick} className={anchorStyles} {...rest}>
      {renderChildren()}
    </a>
  ) : (
    <Link
      to={{ pathname: path, state: { backNavigation: backNavigation } }}
      onClick={handleOnClick}
      className={anchorStyles}
      {...rest}>
      {renderChildren()}
    </Link>
  )
}

AnchorLink.propTypes = {
  path: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.object,
  isNative: PropTypes.bool.isRequired,
  backNavigation: PropTypes.bool,
  isReactLink: PropTypes.bool // a link that is  part of react-router. e.g. should not be external link or corporate pages link
}

AnchorLink.defaultProps = { className: '', icon: {}, isReactLink: true, backNavigation: false }

export default AnchorLink
